export default [

  {
    path: '/active-xklottery/index',
    name: 'index',
    component: () => import('@/views/active-xklottery/index'),
    meta: {
      title: '学考锦鲤抽奖，是有点幸运在身上的！'
    }
  },{
    path: '/active-xklottery/lotteryRecord',
    name: 'lotteryRecord',
    component: () => import('@/views/active-xklottery/lotteryRecord'),
    meta: {
      title: '学考锦鲤抽奖，是有点幸运在身上的！'
    }
  },{
    path: '/active-xklottery/lotteryForm',
    name: 'lotteryForm',
    component: () => import('@/views/active-xklottery/lotteryForm'),
    meta: {
      title: '学考锦鲤抽奖，是有点幸运在身上的！'
    }
  },{
    path: '/active-xklottery/invite',
    name: 'invite',
    component: () => import('@/views/active-xklottery/invite'),
    meta: {
      title: '学考锦鲤抽奖，是有点幸运在身上的！'
    }
  },
]
